import { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import portalStyles from './Portal.module.scss';
const Portal = ({ children, className, zIndex }) => {
    const el = useMemo(() => document.createElement('div'), []);
    useEffect(() => {
        const target = document.body;
        const classList = [portalStyles['portal-container']];
        if (className)
            className.split(' ').forEach((item) => classList.push(item));
        classList.forEach((item) => el.classList.add(item));
        target.appendChild(el);
        return () => {
            target.removeChild(el);
        };
    }, [el, className]);
    useEffect(() => {
        if (typeof zIndex === 'number') {
            el.style.zIndex = String(zIndex);
        }
    }, [el, zIndex]);
    return ReactDOM.createPortal(children, el);
};
export default Portal;
